import { useState } from 'react';
import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { Pagination } from 'components/common';
import { Box } from 'components/common/box';
import { LoginHistoryTable } from 'components/common/loginHistory';

const ProfileLogins = () => {
  const {
    messages,
    pageState: { user }
  } = useReduxState();

  const [page, setPage] = useState<number>(1);

  const { data, loading } = useApiData({
    url: `/admin/users/${user.id}/logins?page=${page}`
  });

  return (
    <div className="logins">
      <Box loading={loading} padding={0} title={messages.profileLoginHistory}>
        <LoginHistoryTable loginEntries={data?.loginEntries} />
      </Box>

      <Pagination
        currentPage={page}
        numberOfPages={data?.pages || 1}
        onPageChange={({ page }) => setPage(page)}
      />
    </div>
  );
};

export default ProfileLogins;
